import { render, staticRenderFns } from "./DeleteSurveyConfirmDialog.vue?vue&type=template&id=184b2aef&"
import script from "./DeleteSurveyConfirmDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteSurveyConfirmDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports